module.exports = __webpack_public_path__ + "img/logo.ea2c96bc.png";